import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { Spin, Table, Card, Button } from 'antd';
import { Link } from 'react-router-dom';

import SecuritiesForm from '../../forms/SecuritiesForm';

import ALL_QUERY from '../../graphql/queries/getCustomerSecuritiesQuery.graphql';

const { Column } = Table;

const Securities = (props) => {
  const { loading } = props.data;
  if (loading) {
    return (
      <Spin size="large" />
    );
  }
  const { customerSecurities } = props.data;
  return (
    <div>
      <h2 className="page-title">Factsheet - Securities</h2>
      <Card title="View all securities" bordered={false} className="ec-card">
        <Table dataSource={customerSecurities} rowKey="id">
          <Column
            title="Type"
            dataIndex="type"
            key="type"
          />
          <Column
            title="Address"
            key="address"
            render={(text, record) => (
              <span>
                {record.address}
                <br />
                {record.city}, {record.state} - {record.pincode}
              </span>
            )}
          />
          <Column
            title="Property type"
            dataIndex="property_type"
            key="property_type"
          />
          <Column
            title="Owned By"
            dataIndex="owned_by"
            key="owned_by"
          />
          <Column
            title="Valuation"
            dataIndex="valuation"
            key="valuation"
          />
          <Column
            title="Actions"
            key="actions"
            render={(text, record) => (
              <Button style={{ marginRight: 10 }}>
                <Link to={`${props.match.url}/${record.id}/documents`}>
                  Property Papers
                </Link>
              </Button>
            )}
          />
        </Table>
      </Card>
      <Card title="Add new security" bordered={false} className="ec-card">
        <SecuritiesForm customer_id={props.match.params.id} />
      </Card>
    </div>
  );
};

Securities.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    customerSecurities: PropTypes.array,
  }).isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default graphql(ALL_QUERY, {
  options: ({ match }) => ({ variables: { customer_id: match.params.id } }),
})(Securities);



// WEBPACK FOOTER //
// ./src/pages/factsheet/Securities.jsx